module.exports = __webpack_public_path__ + "static/media/CoBrand-BusinessSchool-COLS.c56d455a.jpg";